module.exports = __webpack_public_path__ + "img/paperplane.svg";